import React,{useState}from"react";
import{Users,AlertCircle}from"lucide-react";
import{BLUE,DARK,SCOPES,msalInstance,dispName}from"../config";
import{Inp,Spin}from"./UI";
import{isInTeams}from"../teams";

export default function Login({onLogin}){
  const[email,setEmail]=useState("");
  const[error,setError]=useState("");
  const[loading,setLoading]=useState(false);

  const goMock=()=>{
    const v=email.trim().toLowerCase();
    if(!v.endsWith("@dacrobotics.com")&&!v.endsWith("@dac-us.com")){setError("Please use your @dacrobotics.com or @dac-us.com email.");return;}
    onLogin({email:v,name:dispName(v),token:null,mode:"demo",role:"User"});
  };

  const goSSO=async()=>{
    setLoading(true);setError("");
    try{
      await msalInstance.initialize();
      if(isInTeams()){
        // Teams iframes can't do full-page redirects — use popup instead
        const resp=await msalInstance.loginPopup({scopes:SCOPES,prompt:"select_account"});
        // Trigger the same login flow as handleRedirectPromise via a custom event
        window.dispatchEvent(new CustomEvent("teams-login",{detail:resp}));
      }else{
        await msalInstance.loginRedirect({scopes:SCOPES,prompt:"select_account"});
      }
    }catch(err){
      if(err.errorCode!=="user_cancelled")setError("Sign-in failed: "+(err.message||err.errorCode));
      setLoading(false);
    }
  };

  return(
    <div className="min-h-screen flex items-center justify-center p-4" style={{background:DARK}}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-block mb-3 rounded-2xl px-5 py-3" style={{background:"white"}}>
            <img src="/dac-robotics-logo.png" alt="DAC Robotics" style={{height:"48px",width:"auto",display:"block"}}/>
          </div>
          <p className="text-xs tracking-widest font-semibold mb-2" style={{color:"#4A6FA5"}}>TASKHUB</p>
          <p className="text-sm" style={{color:"#8BADD4"}}>Sign in with your DAC Robotics email</p>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-2xl space-y-4">
          <button onClick={goSSO} disabled={loading} className="w-full py-2.5 rounded-xl text-sm font-semibold text-white flex items-center justify-center gap-2 hover:opacity-90 disabled:opacity-60" style={{background:BLUE}}>
            {loading?<Spin/>:<Users size={15}/>}Sign in with Microsoft 365
          </button>
          <div className="flex items-center gap-3"><div className="flex-1 h-px bg-slate-200"/><span className="text-xs text-slate-400">or demo mode</span><div className="flex-1 h-px bg-slate-200"/></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">Work Email</label><Inp type="email" value={email} onChange={e=>{setEmail(e.target.value);setError("");}} onKeyDown={e=>e.key==="Enter"&&goMock()} placeholder="you@dacrobotics.com"/></div>
          {error&&<p className="text-xs text-red-500 flex items-center gap-1"><AlertCircle size={11}/>{error}</p>}
          <button onClick={goMock} disabled={!email.trim()} className="w-full py-2.5 rounded-xl text-sm font-semibold border border-slate-200 text-slate-600 disabled:opacity-50 hover:bg-slate-50">Demo (no data saved)</button>
          <p className="text-center text-xs" style={{color:"#94A3B8"}}>No access? <a href="mailto:mark.ganninger@dacrobotics.com" className="underline" style={{color:BLUE}}>Request access</a></p>
        </div>
      </div>
    </div>
  );
}
